import { createImageLabelBrowseLoader } from '@modules-rocco/projects/page/image-label-browse-loader.server';
import ProjectImageLabelBrowsePage from '@modules-rocco/projects/page/ProjectImageLabelBrowsePage';
import { imageLabelBrowseHandle } from '@modules-rocco/projects/page/image-label-browse-handle';
import { createImageLabelBrowseMeta } from '@modules-rocco/projects/page/image-label-browse-meta';
import { imageLabelShouldRevalidate } from '@modules-rocco/projects/page/image-label-browse-revalidate';

/** Browse project photography by the room or space it shows. */
export const loader = createImageLabelBrowseLoader('spaces');

export const meta = createImageLabelBrowseMeta('spaces');

export const handle = imageLabelBrowseHandle;
export const shouldRevalidate = imageLabelShouldRevalidate;

export default ProjectImageLabelBrowsePage;
